/**
 * This is a wrapper component for different Layouts. Main content should be added to this wrapper.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './LayoutWrapperMain.module.css';

const LayoutWrapperMain = ({
  className = '',
  rootClassName = '',
  children,
}) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes} role="main">
      {children}
    </div>
  );
};

LayoutWrapperMain.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default LayoutWrapperMain;
